import { render, staticRenderFns } from "./TableIcon.vue?vue&type=template&id=447cf5ce&scoped=true"
import script from "./TableIcon.vue?vue&type=script&lang=js"
export * from "./TableIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447cf5ce",
  null
  
)

export default component.exports